import { ToastMixin } from '../../mixins/globalUtils';
import Papa from 'papaparse';
import { defineComponent } from 'vue';

interface ICsvReader {
  headers: string[] | null;
  createToast?: ToastMixin;
}

export default defineComponent({
  name: 'CsvReader',
  emits: ['headers'],
  data(): ICsvReader {
    return {
      headers: null,
    };
  },

  watch: {
    headers() {
      this.$emit('headers', this.headers);
    },
  },

  methods: {
    triggerFileUpload() {
      (this.$refs.file as any).click();
    },

    uploadFile() {
      const inputRef: HTMLInputElement = this.$refs.file as HTMLInputElement;
      const files = inputRef.files;
      if (!files) {
        return;
      }

      const file = files[0];

      Papa.parse(file, {
        header: true,
        dynamicTyping: true,
        // Load only the first row, because only headers are needed
        preview: 1,
        encoding: 'iso-8859-1',
        skipEmptyLines: true,
        complete: (results) => {
          if (results.errors.length) {
            this.createToast!(
              this.$t('errors.error'),
              this.$t('errors.error'),
              'danger',
            );

            return;
          }

          if (!results) {
            return;
          }

          this.headers = Object.keys(
            results.data[0] as { [key: string]: string | number | null },
          );
        },
      });
    },
  },
});
